<bp-hl-area-container [name]="titel">
	@if (!istKaPunkt) {
		<div class="alert alert-warning" data-testid="ka-maske-falsches-verfahren">
			Dieser Punkt ist keine Aufnahme nach der Bodenkundlichen Kartieranleitung. Die Maske wird
			deshalb nicht angezeigt; das Kartierverfahren steht beim Anlegen des Projekts fest.
		</div>
	} @else {
		<div class="touch-form">
			<!-- Die Punktart steht nicht im Bogen: Sie ist die Angabe der App und
			     entscheidet über das Symbol auf der Karte. Sie bleibt auch in
			     KA-Projekten (Nutzer-Entscheidung 20.09.2026); die Aufschlussart der
			     Kartieranleitung (Feld 9) steht weiter unten und ist etwas anderes. -->
			<div class="form-row">
				<div class="form-label-cell wrap-label" title="Symbol auf der Karte. Steht nicht im Bogen der Kartieranleitung.">Punktart</div>
				<div class="form-input-cell">
					<bp-punktart-picker *ngIf="!commenting" [type]="data.type" (typeChange)="onPunktartPicked($event)"></bp-punktart-picker>
					<wd-typeahead *ngIf="commenting" [(model)]="punktartModel" name="PunktartMitProtokoll"></wd-typeahead>
				</div>
				<div class="form-label-cell wrap-label" [title]="hinweis(f.aufschlussart)">{{ beschriftung(f.aufschlussart) }}</div>
				<div class="form-input-cell">
					<wd-text-input [name]="name(f.aufschlussart)" [model]="text(f.aufschlussart)" (modelChange)="setze(f.aufschlussart, $event)" [nonEmpty]="pflicht(f.aufschlussart)"></wd-text-input>
				</div>
			</div>

			<div class="form-section-header">Titeldaten nach dem Aufnahmeformblatt</div>

			<div class="form-row">
				<div class="form-label-cell wrap-label" [title]="hinweis(f.tkNr)">{{ beschriftung(f.tkNr) }}</div>
				<div class="form-input-cell">
					<wd-text-input [name]="name(f.tkNr)" [model]="text(f.tkNr)" (modelChange)="setze(f.tkNr, $event)" [nonEmpty]="pflicht(f.tkNr)"></wd-text-input>
				</div>
				<div class="form-label-cell wrap-label" [title]="hinweis(f.projektNr)">{{ beschriftung(f.projektNr) }}</div>
				<div class="form-input-cell">
					<wd-text-input [name]="name(f.projektNr)" [model]="text(f.projektNr)" (modelChange)="setze(f.projektNr, $event)" [nonEmpty]="pflicht(f.projektNr)"></wd-text-input>
				</div>
			</div>

			<!-- Profil-Nr., Datum und Bearbeiter/in liegen im Punkt an ihrer üblichen
			     Stelle (header…), für jedes Verfahren gleich: Karte, Liste, Suche und
			     Gastmodus lesen sie dort. Deshalb stehen hier die gewohnten Feldnamen
			     ("Nummer", "Aufnahmedatum", "Kartierer") mit ihren Einstellungen. -->
			<div class="form-row">
				<div class="form-label-cell wrap-label" [title]="hinweis(f.profilNr)">{{ beschriftung(f.profilNr) }}</div>
				<div class="form-input-cell">
					<wd-text-input name="Nummer" [(model)]="data.header.nummer" nonEmpty (modified)="onNummerChanged($event)"></wd-text-input>
				</div>
				<div class="form-label-cell wrap-label" [title]="hinweis(f.datum)">{{ beschriftung(f.datum) }}</div>
				<div class="form-input-cell">
					<wd-date-input *ngIf="canSeePersonalData()" name="Aufnahmedatum" [(model)]="data.header.aufnahme.datum" nonEmpty></wd-date-input>
					<span *ngIf="!canSeePersonalData()" class="masked-value">–</span>
				</div>
			</div>

			<div class="form-row">
				<div class="form-label-cell wrap-label" [title]="hinweis(f.bearbeiter)">{{ beschriftung(f.bearbeiter) }}</div>
				<div class="form-input-cell">
					<!-- Nur lesend: Der Bearbeiter hängt am Eigentum des Punktes, und das
					     umzuhängen ist eine eigene, dem Eigentümer vorbehaltene Handlung. -->
					<span *ngIf="canSeePersonalData()" class="readonly-value">{{ data.header.aufnahme.kartierer || '–' }}</span>
					<span *ngIf="!canSeePersonalData()" class="masked-value">–</span>
				</div>
				<div class="form-label-cell wrap-label" [title]="hinweis(f.aufnahmetiefe)">{{ beschriftung(f.aufnahmetiefe) }}</div>
				<div class="form-input-cell">
					<wd-number-input name="Aufnahmetiefe" [(model)]="data.header.aufnahme.tiefe" unit="cm"></wd-number-input>
				</div>
			</div>

			<div class="form-section-header">Lage</div>

			<div class="form-row">
				<div class="form-label-cell wrap-label">Koordinaten</div>
				<div class="form-input-cell multi equal-width" style="grid-column: span 3;">
					<wd-list-input [(model)]="data.header.koordinaten.system" name="Koordinatensystem" label="System" tableName="Koordinatensysteme" nonEmpty></wd-list-input>
					<wd-number-input [(model)]="data.header.koordinaten.x" name="X-Koordinate" [label]="f.ostwert.name" class="label-right" nonEmpty></wd-number-input>
					<wd-number-input [(model)]="data.header.koordinaten.y" name="Y-Koordinate" [label]="f.nordwert.name" class="label-right" nonEmpty></wd-number-input>
				</div>
			</div>

			<div class="form-row">
				<div class="form-label-cell wrap-label" [title]="hinweis(f.hoeheNhn)">{{ beschriftung(f.hoeheNhn) }}</div>
				<div class="form-input-cell">
					<wd-number-input [name]="name(f.hoeheNhn)" [model]="zahl(f.hoeheNhn)" (modelChange)="setze(f.hoeheNhn, $event)" [nonEmpty]="pflicht(f.hoeheNhn)" unit="m"></wd-number-input>
				</div>
			</div>

			<div class="form-section-header">{{ beschriftung(f.titelBemerkungen) }}</div>

			<div class="form-row">
				<div class="form-input-cell" style="grid-column: span 4;">
					<wd-multiline-text-input name="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
				</div>
			</div>
		</div>
		<div class="ka-fusszeile" data-testid="ka-maske-fuss">{{ fussText }}</div>
	}
</bp-hl-area-container>
